"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentLengthHeader = exports.getContentTypeHeader = exports.getAuthorisationHeader = exports.coerceNumericHeaderValue = void 0;
const number_1 = require("../data/number");
/**
 * Attempt to coerce the header {@link value} into a native number.
 * Otherwise use the {@link fallback}.
 *
 * @deprecated use `parseIntegerFromString` directly.
 */
const coerceNumericHeaderValue = (value, fallback) => {
    return (0, number_1.parseIntegerFromString)(value, fallback);
};
exports.coerceNumericHeaderValue = coerceNumericHeaderValue;
/**
 * Retrieve the value of the `Authorization` header.
 */
const getAuthorisationHeader = (headers) => {
    return headers['Authorization'] ?? headers['authorization'];
};
exports.getAuthorisationHeader = getAuthorisationHeader;
/**
 * Retrieve the value of the `Content-Type` header.
 */
const getContentTypeHeader = (headers) => {
    return headers['Content-Type'] ?? headers['content-type'];
};
exports.getContentTypeHeader = getContentTypeHeader;
/**
 * Retrieve the value of the `Content-Length` header.
 */
const getContentLengthHeader = (headers) => {
    return headers['Content-Length'] ?? headers['content-length'];
};
exports.getContentLengthHeader = getContentLengthHeader;
